import { CheckCircle2 } from 'lucide-react';

const items = [
  {
    title: 'Soluções pensadas para o seu negócio',
    description:
      'Nada de pacote pronto. Cada projeto é desenhado para resolver os seus problemas específicos.',
  },
  {
    title: 'Código limpo e escalável',
    description:
      'Seguimos boas práticas de engenharia para que seu sistema cresça sem dor de cabeça.',
  },
  {
    title: 'Foco em resultado, não só em tecnologia',
    description:
      'Tecnologia é o meio. Nosso objetivo é gerar impacto real no seu negócio.',
  },
  {
    title: 'Comunicação clara e parceria real',
    description:
      'Sem jargões. Sem surpresas. Você acompanha cada etapa com total transparência.',
  },
];

export function Differentials() {
  return (
    <section id="diferenciais" className="py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-start">
          <div>
            <p className="text-sm font-semibold uppercase tracking-widest text-accent">
              Diferenciais
            </p>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground sm:text-4xl text-balance">
              Por que escolher a Limiar?
            </h2>
            <p className="mt-4 leading-relaxed text-muted-foreground">
              Combinamos visão estratégica com excelência técnica para entregar
              soluções que realmente fazem diferença.
            </p>
          </div>

          <div className="grid gap-6">
            {items.map((item) => (
              <div key={item.title} className="flex gap-4">
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-accent" />
                <div>
                  <h3 className="font-heading text-sm font-semibold text-foreground">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
